var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{ref:"metricsIframe",style:({ width: '1px', minWidth: '100%', marginTop: '-25px' }),attrs:{"src":_vm.flows_metrics_dashboard,"frameborder":"0"},on:{"load":_vm.onMetricsIframeLoad}})])
}
var staticRenderFns = []

export { render, staticRenderFns }